import { RouteNames } from 'constants/routeNames'
import Dashboard from './pages/Dashboard'

export default {
  routes: [
    {
      key: 'MYATD_DASHBOARD',
      type: 'private',
      title: 'MyATD - Dashboard',
      path: `/${RouteNames.MYATD}/${RouteNames.DASHBOARD}`,
      component: Dashboard,
      exact: true,
    },
  ],
}
